<template>
  <div class="attention" v-if="banner.banner_type == 31 && $newAttention">
    <div>
      <img :src="banner.ad_picture" alt="" />
      <button>关注后，可享受更多服务~</button>
    </div>
  </div>
</template>

<script>
import MaskBannerApis from '@/apis/maskservice/MaskBannerApis'
function getNextRouterQueryParam() {
  if (typeof window === 'undefined') {
    return {}
  }
  const split1 = window.location.search.split('?')
  if (split1.length > 1) {
    const split2 = split1[1].split('&')
    return split2
      .map((i) => {
        const split3 = i.split('=')
        const key = split3[0]
        const value = split3[1]
        return { [key]: value }
      })
      .reduce((a, b) => {
        return { ...a, ...b }
      })
  }
  return {}
}
export default {
  //  props: ['src'],
  data() {
    return {
      banner: ''
    }
  },
  mounted() {
    const params = getNextRouterQueryParam()
    let fromChanner = params.from_channel
    if (fromChanner && fromChanner.startsWith('banner_')) {
      const bannerId = fromChanner.substring(7)
      MaskBannerApis.getBanner(bannerId).then((res) => {
        this.banner = res.data
      })
    }
  }
}
</script>

<style scoped lang="less">
.attention {
  width: 100%;
  position: fixed;
  height: 100%;
  z-index: 100;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  > div {
    width: 70%;
    display: flex;
    flex-direction: column;
    img {
      display: block;
      width: 100%;
      border-radius: 0.25rem 0.25rem 0 0;
    }
    button {
      color: #fff;
      background: #35b6a4;
      border: 0;
      font-size: 0.43rem;
      height: 1.5rem;
      border-radius: 0 0 0.25rem 0.25rem;
    }
  }
}
</style>
